import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import c from '../home.Module.scss';
import { Resources } from '../../../config/Resources';
import Box from '@mui/system/Box';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Button from '@mui/material/Button';
import {
  inCompleteProfileTabsDetail,
  learnerData,
} from '../../../helpers/Home/Stats';
import { googleAnalyticsTriggerFn } from '../../../utils/utility';
import Text from '../../Shared/Text';
import { CustomIframe } from '../../Shared/CustomIframe';

const Stats = () => {
  const history = useHistory();
  const [selectedLink, setSelectedLink] = useState('');
  const profilePercentageStatus = useSelector(
    (state) => state?.profileCompletionStatus?.percentage
  );
  const isProfileComplete = profilePercentageStatus == 100 ? true : false;
  const profileIncompleteTabs = useSelector(
    (state) => state?.profileCompletionStatus?.incompleteTabs
  );
  return (
    <div
      className={classNames(
        'h-100 w-100 bg-white rounded-3 row g-0 justify-content-center align-items-center',
        c.stats
      )}
    >
      <div className={classNames('col-2', c.statsImgContainer)}>
        <img
          src={Resources?.images?.home?.stats}
          alt="stats"
          className="h-auto w-100"
        />
      </div>
      <div className="col-10 pt-4 ps-3">
        {/* <div className={classNames('fw-bold', c.progressHeading)}>
          You’re almost there! Continue with your progress and become a standout
          performer!
        </div>
        <div className={classNames('pt-2', c.fontWeight500, c.performanceStat)}>
          Use information on this page to review performance for you and your
          colleagues, start study sessions in backlog and access your profile to
          set new goals
        </div> */}
        <Text classToOverride={classNames('pb-1', c.headingCls)}>
          Lifelong learning companion for your Career growth
        </Text>
        {learnerData.map((item) => (
          <div className="px-3 pb-1 d-flex flex-row align-items-center">
            <Text classToOverride={classNames(c.subHeadingCls)}>
              {item.heading}:
            </Text>
            <a
              className={classNames(c.descriptionCls, c.cursorPointer)}
              onClick={() => setSelectedLink(item.redirectionUrl)}
            >
              {item?.heading === 'Winning' && <span className={c.fontWeight600}>{item.prefixText}</span>}
              {item.description}
            </a>
          </div>
        ))}

        <CustomIframe
          iconClass={c.cursorPointer}
          selectedLink={selectedLink}
          setSelectedLink={setSelectedLink}
        />

        <div
          className={classNames(
            'd-flex flex-wrap justify-content-between align-items-center',
            c.profileStatContainer
          )}
        >
          <Box display="flex" pr={5}>
            <InfoRoundedIcon
              className={classNames(
                'text-white rounded-circle',
                c.statsInfoIcon
              )}
            />
            <div className="mb-1 d-flex flex-wrap flex-column">
              <div
                className={classNames(
                  'ps-2',
                  c.fontWeight500,
                  c.profileCompletionStat
                )}
              >
                Your profile is {profilePercentageStatus || 0}% complete.
                {isProfileComplete ? (
                  <></>
                ) : (
                  <>
                    {' '}
                    Following item(s) need to be updated to complete your
                    profile:
                  </>
                )}
              </div>
              <Breadcrumbs
                separator={
                  <FiberManualRecordIcon className={c.statsSeparatorIcon} />
                }
                aria-label="profileItems"
              >
                {profileIncompleteTabs &&
                  profileIncompleteTabs.length > 0 &&
                  profileIncompleteTabs.map((item) => (
                    <Button
                      key={inCompleteProfileTabsDetail[item]?.id}
                      className={classNames(
                        'text-capitalize',
                        c.profileCompletionItems
                      )}
                      onClick={() => {
                        history.push(
                          inCompleteProfileTabsDetail[item]?.redirectTo
                        );
                        googleAnalyticsTriggerFn(
                          'Button',
                          inCompleteProfileTabsDetail[item]?.name,
                          `${
                            inCompleteProfileTabsDetail[item]?.name
                          }${' '} clicked`
                        );
                      }}
                      disabled={
                        inCompleteProfileTabsDetail[item]?.disabled
                          ? true
                          : false
                      }
                      size="large"
                    >
                      {/* <span className={c.profileCompletionItems}> */}
                      <u>{inCompleteProfileTabsDetail[item]?.name}</u>
                      {/* </span> */}
                    </Button>
                  ))}
              </Breadcrumbs>
            </div>
          </Box>
          <Button
            variant="contained"
            className="text-capitalize"
            onClick={() => {
              history.push('/profile');
              googleAnalyticsTriggerFn(
                'Button',
                'Update Profile',
                'Update Profile button clicked'
              );
            }}
          >
            Update Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Stats;
